/**
 * @author Ivan Toth.
 */
var DetailTableSampQController = (function () {
    function DetailTableSampQController(topic, env, $scope, $attrs) {
        var _this = this;
        this.topic = topic;
        this.env = env;
        this.$scope = $scope;
        this.$attrs = $attrs;
        this.comp = 'sampling_q';
        this.showButtons = false;
        this.$scope.$on('broadcast:topicUpdated', function (event, data) {
            // If the topic is updated, check if Sampling will be needed
            _this.incentiveStatus = _this.topic.topic.sampling[_this.incentive] || _this.topic.topic.sampling;
            _this.setSamplingMessage();
        });
    }
    /**
     * Function to determine if Sampling should be forced
     */
    DetailTableSampQController.prototype.setSamplingMessage = function () {
        // If validation and pre-calcs and...
        // 1 - CVR Sales Assist (nonGE), sampling needed
        // 2 - If Sampling started, regardless
        this.sampReqMess = undefined; // wipe it
        // If in Validation pre-calcs
        if (this.topic.topic.status.status_no === 4 && !this.topic.areCalcsStarted()) {
            // If Base sampling needed...or it's been started but not finished
            if (this.topic.isBaseSampling() && this.topic.isSamplingStarted() && !this.topic.isSamplingComplete(this.incentive)) {
                this.sampReqMess = 'This Disbursement has been flagged for Base Sampling and must be completed (or manually overridden) before Calculations can be triggered';
            }
            else if (this.topic.isSamplingStarted() && !this.topic.isSamplingComplete(this.incentive)) {
                this.sampReqMess = 'This Disbursement must have Sampling completed (or manually overridden) before Calculations can be triggered';
            }
        }
        else if (this.topic.topic.status.status_no === 7) {
            // If GE and sampling not done yet
            if (this.topic.isGOE() && this.topic.isSamplingStarted() && !this.topic.isSamplingComplete(this.incentive)) {
                this.sampReqMess = 'This Disbursement must have Sampling completed (or manually overridden)';
            }
        }
    };
    DetailTableSampQController.prototype.$onInit = function () {
        this.incentive = this.$attrs.incentive;
        this.incentiveStatus = this.topic.topic.sampling[this.incentive] || this.topic.topic.sampling;
        this.edit = this.topic.getEditComponent(this.comp);
        this.setSamplingMessage();
    };
    DetailTableSampQController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            // Check if we can update the values if yes continue to update temp
            this.edit.editMode = this.topic.setTopicFromTempPart(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
    };
    DetailTableSampQController.$inject = ['topic', 'env', '$scope', '$attrs', '$state', 'settings', 'socket', 'admin', 'notify'];
    return DetailTableSampQController;
}());
var DetailTableSampQComponent = (function () {
    function DetailTableSampQComponent() {
        this.templateUrl = 'detail-table-sampq.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableSampQController;
    }
    return DetailTableSampQComponent;
}());
angular
    .module('application')
    .component('detailTableSampQ', new DetailTableSampQComponent());

//# sourceMappingURL=detail.table.samp_q.component.js.map
